import React, { useState } from 'react';
import Navbar from '../../component/Navbar';
import Footer from '../../component/Footer';
import Arrow from '../Arrow';
import Generalsidebar from '../Generalsidebar';

function MainPayment() {
  const [showSidebar, setShowSidebar] = useState(false);

  const userInfo = JSON.parse(localStorage.getItem('userLoggedIn'))
    ? JSON.parse(localStorage.getItem('userLoggedIn'))
    : { firstName: '' };

  console.log('userInfo', userInfo);
  function handleArrowClick() {
    setShowSidebar(true);
  }

  return (
    <div>
      <Navbar />

      <div onClick={handleArrowClick} className='absolute top-24 left-12 z-20'>
        <Arrow />
      </div>
      <div className={showSidebar ? 'show-sidebar' : 'hidden'}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>

      <div className='bg-[#D4DDCC] py-10'>
        <div className='container mx-auto'>
          <h1 className='text-2xl text-center text-[#295700] font-semibold mt-4 mb-8 text-align'>
            Welcome to Thrive Premium Package Plan!
          </h1>
          <div className='grid grid-cols-1 md:grid-cols-3 gap-8 md:px-6'>
            {/* Gold Plan Card */}
            <div className='bg-white p-6 rounded shadow-md'>
              <h2 className='text-xl font-sans-serif mb-2'>Gold Plan</h2>
              <p className='text-gray-600 mb-4'>
                With #30,000 a month, we welcome you to enjoy our highest
                premium package that offers you: <br />
                <br />
                <strong className='flex gap-1 mb-2'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    className='w-4 h-4 relative top-1'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M8.25 4.5l7.5 7.5-7.5 7.5'
                    />
                  </svg>
                  <p>10 freetherapy sessions </p>
                </strong>
                <strong className='flex gap-1 mb-6'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    className='w-4 h-4 relative top-1'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M8.25 4.5l7.5 7.5-7.5 7.5'
                    />
                  </svg>
                  <p>Unlimited access to all relaxation features</p>
                </strong>
              </p>
              <a href='https://paystack.com/pay/premium-gold-plan'>
                <button className='bg-gray-500 hover:bg-green-600 text-white px-4 py-2 rounded-full  mr-4'>
                  Upgrade to Gold
                </button>
              </a>
            </div>
            {/* Silver Plan Card */}
            <div className='bg-white p-6 rounded shadow-md'>
              <h2 className='text-xl font-semibold mb-2'>Silver Plan</h2>
              <p className='text-gray-600 mb-4'>
                With #20,000 a month, we welcome you to enjoy our silver premium
                package that offers you: <br />
                <br />
                <strong className='flex gap-1 mb-2'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    className='w-4 h-4 relative top-1'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M8.25 4.5l7.5 7.5-7.5 7.5'
                    />
                  </svg>
                  <p>6 freetherapy sessions </p>
                </strong>
                <strong className='flex gap-1 mb-6'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    className='w-4 h-4 relative top-1'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M8.25 4.5l7.5 7.5-7.5 7.5'
                    />
                  </svg>
                  <p>Unlimited access to all relaxation features</p>
                </strong>
              </p>
              <a href='https://paystack.com/pay/premium-silver-plan'>
                <button className='bg-gray-500 hover:bg-green-600 text-white px-4 py-2 rounded-full '>
                  Upgrade to Silver
                </button>
              </a>
            </div>
            {/* Bronze Plan Card */}
            <div className='bg-white p-6 rounded shadow-md '>
              <h2 className='text-xl font-semibold mb-2'>Bronze Plan</h2>
              <p className='text-gray-600 mb-4'>
                With #10,000 a month, we welcome you to enjoy our bronze premium
                package that offers you: <br />
                <br />
                <strong className='flex gap-1 mb-2'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    className='w-4 h-4 relative top-1'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M8.25 4.5l7.5 7.5-7.5 7.5'
                    />
                  </svg>
                  <p>2 freetherapy sessions </p>
                </strong>
                <strong className='flex gap-1 mb-6'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    className='w-4 h-4 relative top-1'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M8.25 4.5l7.5 7.5-7.5 7.5'
                    />
                  </svg>
                  <p>Unlimited access to all relaxation features</p>
                </strong>
              </p>
              <a href='https://paystack.com/pay/premium-bronze-plan'>
                <button className='bg-gray-500 hover:bg-green-600 text-white px-4 py-2 rounded-full '>
                  Upgrade to Bronze
                </button>
              </a>
            </div>
          </div>
        </div>

        <div className='mt-6'>
          <a href='https://paystack.com/pay/thrive-pay-per-session'>
            <button className='bg-green-500 text-white px-4 py-2 mb-4 block mx-auto rounded-full hover:bg-green-600'>
              One off Payment?
            </button>
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MainPayment;
